import { toCSSPixel } from '../../../utils/styles'

import * as styles from './TableCellFreeSpaceFiller.module.css'

function TableCellFreeSpaceFiller({
  className = styles.TableCellFreeSpaceFiller,
  width,
}) {
  return width ? (
    <div className={className} style={{ width: toCSSPixel(width) }} />
  ) : null
}

export default TableCellFreeSpaceFiller
